import { DotMatrix, StatCard } from '@clickguard/design-system'
import { AccessLogDTO } from 'api-models'
import { GDateTime } from 'components/basic-blocks/g-datetime'
import { Lock01 } from 'components/icons'
import { useStores } from 'hooks'
import { useEffect } from 'react'
import { useUiStore } from 'store'

export const AccessLogs = () => {
	const { userStore } = useStores()
	const { getAccessLogs, accessLogs } = userStore
	const isLoading = useUiStore((s) => s.isLoading)

	useEffect(() => {
		const getData = async () => {
			await getAccessLogs()
		}
		getData()
	}, [])

	return (
		<StatCard
			size="regular"
			divider={false}
			className="w-full !p-4 !gap-4"
			title={
				<span className="text-[18px] leading-6 font-medium text-t-base-blue">
					Login history
				</span>
			}
		>
			{isLoading('USER_GET_LOGIN_METHODS') ? (
				<div className="flex justify-center py-8">
					<DotMatrix size="lg" />
				</div>
			) : !accessLogs || accessLogs.length === 0 ? (
				<p className="text-[14px] leading-[18px] text-[color:var(--text-secondary)]">
					There are no recent logins
				</p>
			) : (
				accessLogs.map((row, i) => renderItem(row, i))
			)}
		</StatCard>
	)
}

function renderItem(item: AccessLogDTO, i: number) {
	return (
		<div
			key={'' + i + item.timestamp}
			className="flex items-center justify-between gap-4 rounded-xl border border-t-checkbox p-[13px]"
		>
			<div className="flex min-w-0 flex-1 items-center gap-4">
				<Lock01 className="h-6 w-6 shrink-0 text-[color:var(--text-secondary)]" />
				<div className="flex min-w-0 flex-col gap-0.5">
					<p className="truncate text-[16px] leading-[22px] text-[color:var(--text-primary)]">
						{item.user_agent}
					</p>
					<p className="truncate font-mono text-[12px] uppercase leading-4 tracking-[-0.12px] text-[color:var(--text-secondary)]">
						IP: {item.ip}
					</p>
				</div>
			</div>
			<div className="shrink-0 whitespace-nowrap text-[14px] leading-[18px] text-[color:var(--text-secondary)]">
				<GDateTime date={item.timestamp} />
			</div>
		</div>
	)
}
